import { render, staticRenderFns } from "./StudentRedcord.vue?vue&type=template&id=d4634a4c&scoped=true&"
import script from "./StudentRedcord.vue?vue&type=script&lang=js&"
export * from "./StudentRedcord.vue?vue&type=script&lang=js&"
import style0 from "./StudentRedcord.vue?vue&type=style&index=0&id=d4634a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4634a4c",
  null
  
)

export default component.exports